import { useEffect, useLayoutEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
    addUsersToRole,
    creatRole,
    getEmployesWithRole,
    GetSingleRole,
    removeRoleToUserByIds,
    roleAvailableTasks,
    UpdateRole,
} from '../../../../../reduxToolkit/EmployeeRoles/EmployeeRolesApi';
import { useRoleRestrictionsArray } from './RoleRestriction';
import {
    EmployeesInCreate,
    HandleEmployeesWithRole,
} from '../../../../../reduxToolkit/EmployeeRoles/EmployeeRolesSlice';
import { errorMsg, getFullName } from '../../../../../Apis/functions';
import routes from '../../../../../Routes/routes';
import { MODELS } from '../../../../../Apis/Models';
import { ROLE_NAME_DEFAULT_MODEL } from '../../../../../enums/userTypeEnum';
import {
    CREATE_UPDATE_ROLE_MODEL,
    ROLE_MODEL,
    ROLE_RESTRICTION_MODEL,
    STEPS_CREATE_NEW_ROLE,
} from '../Model/AllowedModules';
import HandleChange from '../../../../../Helpers/HandleChange';

/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle: Frontend - IBL
 * @Email: sgarcia@ibl.mx
 */

const CreateNewRoleApp = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { roleListData, singleRoleObj, updateRoleSuccess, creteRoleSuccess } = useSelector(
        (state) => state?.EmployeeRolesSlice,
    );

    const mobile = roleListData?.filter((item) => item?.isMobileApp);
    const web = roleListData?.filter((item) => !item?.isMobileApp);
    const arrObj = useRoleRestrictionsArray();
    const [mobileAvailableList, setMobileAvaliableList] = useState([]);
    const [websiteAvailableList, setWebsiteAvailableList] = useState([]);
    const [deleteTask, setDeleteTask] = useState([]);
    const [roleDataById, setRoleDataById] = useState();
    const [mobileAll, setMobileAll] = useState([]);
    const [webAll, setWebAll] = useState([]);
    const [steps, setSteps] = useState([]);

    const [activeStep, setActiveStep] = useState(STEPS_CREATE_NEW_ROLE.SET_UP_PRIVILEGES);
    const [selected, setSelected] = useState([]);
    const [emptyFields, setEmptyFields] = useState(false);
    const [selectedPermissions, setSelectedPermissions] = useState();
    const [updateSteps, setUpdateSteps] = useState([]);
    const [initialUsers, setInitialUsers] = useState([]);
    const [item, setItem] = useState({ ...ROLE_MODEL });
    const [update, setUpdate] = useState(false);
    const [selectedRestrictions, setSelectedRestrictions] = useState({
        ...ROLE_RESTRICTION_MODEL,
    });
    const [nameError, setNameError] = useState('');
    const [submitClicked, setSubmitClicked] = useState(false);
    const [modified, setModified] = useState(false);
    const [validate, setValidate] = useState(false);
    const [emptyPrivilege, setEmptyPrivilege] = useState(false);
    const [createUpdatePrivilege, setCreateUpdatePrivilege] = useState(false);

    const roleName = item?.roleName?.toUpperCase() || '';

    const readOnly = Object.values(ROLE_NAME_DEFAULT_MODEL).includes(roleName);

    const { handleChange } = HandleChange({ model: item, setModel: setItem });

    const { id } = useParams();
    // Initializes the state for role restrictions with default values

    const [roleRestrictions, setroleRestrictions] = useState([
        {
            name: 'biocrValidation',
            res: t('biocr_validation'),
            check: false,
            info: t('use_the_biocr_validatiaon_to_confirm_your_identity'),
        },
        {
            name: 'eventValidation',
            res: t('event_validation'),
            check: false,
            info: t('validate_the_event_who_created_in_this_role'),
        },
        {
            name: 'extraDataEmployee',
            res: t('extra_data_employee'),
            check: false,
            info: t('add_extra_data_to_the_employee'),
        },
        {
            name: 'keepSessionActiveWebApp',
            res: t('keep_session_active'),
            check: false,
            info: t('to_keep_the_session_al_the_time_active_in_the_web_app'),
        },

        {
            name: 'sharePdfInMobileApp',
            res: t('share_pdf_in_mobile_app'),
            check: false,
            info: t('to_use_the_6_degits_code_to_log_in_on_the_web_app'),
        },
        {
            name: 'useTokenWebApp',
            res: t('use_token_webapp'),
            check: false,
            info: t('to_use_the_6_degits_code_to_log_in_on_the_web_app'),
        },
    ]);

    // Clear all form fields and reset role state
    const clearField = () => {
        setItem({ ...ROLE_MODEL });
        setSelectedPermissions([]);
        setSelectedRestrictions(ROLE_RESTRICTION_MODEL.clear());
        setEmptyFields(false);
        setEmptyPrivilege(false);
    };

    useEffect(() => {
        if (!id) {
            clearField();
        }
    }, [id]);

    const handleClearEmployees = () => {
        setSelected([]);
        setEmptyFields(false);
    };

    // Handle creation or updating of a role based on the presence of an ID
    const handleCreateRole = async () => {
        setCreateUpdatePrivilege(true);
        if (item.isValid()) {
            if (id) {
                const isRootRole = singleRoleObj?.name?.toUpperCase() === ROLE_NAME_DEFAULT_MODEL.ROLE_ROOT;

                if (isRootRole) {
                    const newUsers = selected.filter(
                        (selectedUser) =>
                            !initialUsers.some((initialUser) => initialUser.userId === selectedUser.userId),
                    );

                    if (newUsers.length > 0) {
                        await dispatch(
                            addUsersToRole({
                                userIds: newUsers.map((user) => user.userId),
                                roleId: singleRoleObj?.id,
                            }),
                        );
                        setSelected([]);
                    }
                    dispatch(GetSingleRole(id)).then(
                        ({
                            payload: {
                                data: { data, success, code },
                            },
                        }) => {
                            if (success) {
                                toast.success(t('has_been_updated_successfully'));
                            } else {
                                errorMsg(code);
                            }
                        },
                    );

                    return;
                }

                if (selectedPermissions.length === 0) {
                    toast.warn(t('please_fill_all_fields'));
                    setEmptyPrivilege(true);
                    return;
                }

                const addTasks = selectedPermissions.map((item) => ({
                    id: item.id || item,
                }));

                const initialPermissions = singleRoleObj?.currentTasks?.map((task) => task.id) || [];

                const removeTasks = initialPermissions
                    .filter((id) => !selectedPermissions.some((permission) => permission.id === id))
                    .map((id) => ({ id }));

                const updateData = CREATE_UPDATE_ROLE_MODEL.toRegister({
                    id: singleRoleObj?.id,
                    addTasks,
                    removeTasks,
                    name: item?.roleName,
                    roleRestriction: selectedRestrictions.toRegister(),
                });

                dispatch(UpdateRole(updateData)).then(
                    async ({
                        payload: {
                            data: { success, code },
                        },
                    }) => {
                        if (success !== true) {
                            errorMsg(code);
                        } else {
                            if (selected?.length > 0) {
                                await dispatch(
                                    addUsersToRole({
                                        userIds: selected.map((user) => user.userId),
                                        roleId: singleRoleObj?.id,
                                    }),
                                );

                                setSelected([]);
                                setModified(true);
                            }
                            dispatch(GetSingleRole(id));
                        }
                    },
                );
            } else {
                if (selectedPermissions.length === 0) {
                    setEmptyPrivilege(true);
                    toast.warn(t('please_select_privilege'));
                    return;
                }

                const data = CREATE_UPDATE_ROLE_MODEL.toRegister({
                    addTasks: selectedPermissions,
                    removeTasks: null,
                    name: item?.roleName,
                    roleRestriction: selectedRestrictions.toRegister(),
                });

                dispatch(creatRole(data)).then(
                    async ({
                        payload: {
                            data: { success, code, data: roleData },
                        },
                    }) => {
                        if (success === true) {
                            const userIds = selected.map((user) => user.userId);
                            if (userIds.length > 0) {
                                const response = await dispatch(
                                    addUsersToRole({
                                        userIds,
                                        roleId: roleData.id,
                                    }),
                                );

                                if (response?.payload?.data?.success) {
                                    navigate(routes.roles.list);
                                }
                            } else {
                                navigate(routes.roles.list);
                            }
                        } else {
                            errorMsg(code);
                        }
                    },
                );
            }
        } else {
            setEmptyFields(true);
            toast.warn(t('please_fill_all_fields'));
            setSubmitClicked(true);
        }
    };

    // Reset selected mobile and website tasks on initial render
    useEffect(() => {
        setDeleteTask([]);
    }, []);

    // Mark the component as ready for update logic
    useEffect(() => {
        setUpdate(true);
        dispatch(EmployeesInCreate([]));
        dispatch(HandleEmployeesWithRole([]));
        dispatch(roleAvailableTasks());
    }, []);

    // When role list data is available or updated, split it into mobile and website roles
    useEffect(() => {
        if (!roleListData) return;

        const permissionsToHide = [MODELS.Guard];
        const filtered = roleListData.filter((t) => !permissionsToHide.includes(t.moduleId));

        setMobileAll(filtered.filter((i) => i.isMobileApp));
        setWebAll(filtered.filter((i) => !i.isMobileApp));
    }, [roleListData]);

    // When editing a role (based on ID), fetch its data and prefill the form
    useEffect(() => {
        if (id) dispatch(GetSingleRole(id));
    }, [id]);

    // Loads role information and separates permissions by platform
    useEffect(() => {
        if (!id) return;
        if (!singleRoleObj) return;
        setItem(ROLE_MODEL.set(singleRoleObj));
        setroleRestrictions(arrObj);
        setRoleDataById(singleRoleObj);
        setSelectedRestrictions(ROLE_RESTRICTION_MODEL.set(singleRoleObj?.roleRestriction));
    }, [singleRoleObj]);

    // Returns step labels for role creation flow
    const STEP_NEW_ROLE_CREATE = () => {
        return [t('set_up_privileges'), t('assign_employees'), t('summary')];
    };

    // Updates translated steps when language changes
    useLayoutEffect(() => {
        setSteps(STEP_NEW_ROLE_CREATE);
        setUpdateSteps(STEP_UPDATE);
    }, [t]);

    // Changes the current active step
    const handleStepChange = (step) => {
        setActiveStep(step);
    };

    // Changes the current active step
    const handleDeleteEmployee = (step) => {
        setActiveStep(step);
    };

    // Validates required fields before changing steps
    const handleValidateSteps = (step) => {
        setCreateUpdatePrivilege(true);
        switch (step) {
            case STEPS_CREATE_NEW_ROLE.SET_UP_PRIVILEGES: {
                const hasPermissions = selectedPermissions?.length > 0;
                const isValid = item.isValid();

                const isStepValid = isValid && hasPermissions;

                setEmptyFields(!isValid);
                setEmptyPrivilege(!hasPermissions);
                setValidate(true);
                return isStepValid;
            }
            default:
                return true;
        }
    };

    // Returns step labels for role update flow
    const STEP_UPDATE = () => {
        return [t('privileges'), t('employees')];
    };

    // Formats and stores selected permissions from current tasks
    useEffect(() => {
        if (!id) {
            setSelectedPermissions([]);
            return;
        }
        if (singleRoleObj?.currentTasks) {
            const formattedPermissions = singleRoleObj.currentTasks.map((task) => ({
                id: task.id,
            }));
            setSelectedPermissions(formattedPermissions);
        }
    }, [id, singleRoleObj]);

    const handleDeleteUsers = async (users) => {
        const userIds = Array.isArray(users) ? users : [users.userId];

        await dispatch(
            removeRoleToUserByIds({
                userIds,
                roleId: id,
            }),
        );
        setInitialUsers([]);
        setSelected([]);
        setModified(true);
    };

    useEffect(() => {
        if (selectedPermissions?.length <= 0 && createUpdatePrivilege) {
            setEmptyPrivilege(true);
        } else {
            setEmptyPrivilege(false);
        }
    }, [selectedPermissions, createUpdatePrivilege]);

    return {
        handleCreateRole,
        activeStep,
        steps,
        setUpdateSteps,
        updateSteps,
        setActiveStep,
        handleStepChange,
        handleValidateSteps,
        selected,
        setSelected,
        web,
        mobile,
        handleChange,
        emptyFields,
        selectedPermissions,
        setSelectedPermissions,
        roleListData,
        singleRoleObj,
        id,
        clearField,
        handleClearEmployees,
        readOnly,
        roleListData,
        initialUsers,
        setInitialUsers,
        item,
        handleDeleteUsers,
        modified,
        setModified,
        setEmptyPrivilege,
        emptyPrivilege,
    };
};
export default CreateNewRoleApp;
